import gsap, { Power1 } from 'gsap';

/**
 * @param {HTMLElement} el
 * @param {number} duration
 * @param {() => void} callback
 *
 * @returns {gsap.core.Tween}
 */
export function slideDown(el, duration, callback = () => {}) {
    gsap.set(el, { height: 'auto', display: 'block' });

    const paddingTop = gsap.getProperty(el, 'padding-top');
    const paddingBottom = gsap.getProperty(el, 'padding-bottom');
    const height = `${el.offsetHeight}px`;

    gsap.set(el, {
        height: '0',
        paddingTop: '0',
        paddingBottom: '0',
        overflow: 'hidden',
        zIndex: 1,
    });

    return gsap.to(el, {
        height,
        paddingTop,
        paddingBottom,
        duration,
        overwrite: true,
        ease: Power1.easeOut,
        onComplete: () => {
            gsap.set(el, {
                clearProps: 'overflow,zIndex,paddingTop,paddingBottom,height,minHeight',
            });
            callback();
        },
    });
}

/**
 * @param {HTMLElement} el
 * @param {number} duration
 * @param {() => void} callback
 *
 * @returns {gsap.core.Tween}
 */
export function slideUp(el, duration, callback = () => {}) {
    gsap.set(el, {
        overflow: 'hidden',
        zIndex: 'auto',
        height: `${el.offsetHeight}px`,
        minHeight: '',
    });

    const paddingTop = gsap.getProperty(el, 'padding-top');
    const paddingBottom = gsap.getProperty(el, 'padding-bottom');

    return gsap.to(el, {
        height: '0',
        paddingTop,
        paddingBottom,
        overwrite: true,
        duration,
        ease: Power1.easeOut,
        onComplete: () => {
            gsap.set(el, { clearProps: 'all' });
            callback();
        },
    });
}

/**
 * @param {HTMLElement} el
 * @param {number} duration
 * @param {() => void} callback
 *
 * @returns {gsap.core.Tween}
 */
export function slideToggle(el, duration, callback = () => {}) {
    if (el.offsetHeight > 0) {
        return slideUp(el, duration, callback);
    }

    return slideDown(el, duration, callback);
}
